import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import * as Icon from 'react-bootstrap-icons';

import { initAlergenos, initAplicaciones, initConcentracion, initFase, initFecha, initFrasco, initLado, initPaciente, initSitio, initTipo, initVolumenAlergeno, initVolumenTotal, setAlergenos, setAplicaciones, setComentarios, setConcentracion, setFase, setFecha, setFrasco, setLado, setSitio, setTipo, setVolumenAlergeno, setVolumenTotal } from '../../../redux/slices/inmunoterapia/inmunoterapiaSlice';

import { usePacienteInmunoterapiaProxima } from '../hooks/usePacienteInmunoterapiaProxima';
import { usePacienteInmunoterapiaData } from '../hooks/usePacienteInmunoterapiaData';
import { usePacienteInmunoterapiaFinalizar } from '../hooks/usePacienteInmunoterapiaFinalizar';
import { usePacienteInmunoterapiaEliminar } from '../hooks/usePacienteInmunoterapiaEliminar';

import { Empty, Error, Forbidden, IconButton, Loader } from '../../../components';

import { InmunoterapiaNueva } from './InmunoterapiaNueva';
import { InmunoterapiaActiva } from './InmunoterapiaActiva';

import styles from '../PacienteConsulta.module.css';
import { colors } from '../../../types/types';

export const InmunoterapiaProxima = ({ id }) => {

    const dispatch = useDispatch();

    const { permisos } = useSelector(state => state.auth);

    const dataInmunoterapiaBrowser = useSelector(state => state.inmunoterapia[id]);

    const { pacienteInmunoterapiaProximaQuery: { isLoading, isError, data: inmunoterapias } } = usePacienteInmunoterapiaProxima(id);

    const { finishInmunoterapiaMutation: { mutate: finishInmunoterapia } } = usePacienteInmunoterapiaFinalizar(id);

    const { deleteInmunoterapiaMutation: { mutate: deleteInmunoterapia } } = usePacienteInmunoterapiaEliminar(id);

    const { pacienteInmunoterapiaDataQuery: { isLoading: isLoadingInmunoterapiaData, isError: isErrorInmunoterapiaData, data: dataInmunoterapia, refetch: refetchDataInmunoterapia } } = usePacienteInmunoterapiaData(id);

    const [nuevaStatus, setNuevaStatus] = useState(false);

    const [tab, setTab] = useState(1);

    const [initInmunoterapia, setInitInmunoterapia] = useState(false);

    const handleCrearNueva = () => {
        setNuevaStatus(true);
        setTab(2);
    }

    const handleCancelarNueva = () => {
        setNuevaStatus(false);
        setTab(1);
        //Reestablecimiento de valores
        dispatch(setTipo({ paciente: id, tipo: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.tipo : '' }));
        dispatch(setFase({ paciente: id, fase: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.fase : '' }));
        dispatch(setFecha({ paciente: id, fecha: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.fecha : '' }));
        dispatch(setFrasco({ paciente: id, frasco: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.frasco : '' }));
        dispatch(setConcentracion({ paciente: id, concentracion: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.concentracion : '' }));
        dispatch(setVolumenAlergeno({ paciente: id, volumenAlergeno: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.volumenAlergeno : '' }));
        dispatch(setVolumenTotal({ paciente: id, volumenTotal: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.volumenTotal : '' }));
        dispatch(setSitio({ paciente: id, sitio: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.sitio : '' }));
        dispatch(setLado({ paciente: id, lado: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.lado : '' }));
        dispatch(setAlergenos({ paciente: id, alergenos: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.alergenos : [] }));
        dispatch(setAplicaciones({ paciente: id, aplicaciones: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.aplicaciones : [] }));
        dispatch(setComentarios({ paciente: id, comentarios: '' }));
    }

    const handleFinalizar = (e, id) => {
        e.stopPropagation();
        finishInmunoterapia({ id, refetchDataInmunoterapia, setNuevaStatus, setTab, inmunoterapias: inmunoterapias.length });
    }

    const handleEliminar = (e, id) => {
        e.stopPropagation();
        deleteInmunoterapia(id);
        setTab(1);
    }

    useEffect(() => {
        dispatch(initPaciente({ id }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

    const handleInitData = () => {
        dispatch(initTipo({ id, tipo: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.tipo : '' }));
        dispatch(initFase({ id, fase: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.fase : '' }));
        dispatch(initFecha({ id, fecha: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.fecha : '' }));
        dispatch(initFrasco({ id, frasco: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.frasco : '' }));
        dispatch(initConcentracion({ id, concentracion: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.concentracion : '' }));
        dispatch(initVolumenAlergeno({ id, volumenAlergeno: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.volumenAlergeno : '' }));
        dispatch(initVolumenTotal({ id, volumenTotal: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.volumenTotal : '' }));
        dispatch(initSitio({ id, sitio: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.sitio : '' }));
        dispatch(initLado({ id, lado: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.lado : '' }));
        dispatch(initAlergenos({ id, alergenos: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.alergenos : [] }));
        dispatch(initAplicaciones({ id, aplicaciones: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.aplicaciones : [] }));
        setTimeout(() => {
          setInitInmunoterapia(true);
        }, 1000);
    }

    const handleSetData = () => {
        dispatch(setTipo({ paciente: id, tipo: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.tipo : '' }));
        dispatch(setFase({ paciente: id, fase: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.fase : '' }));
        dispatch(setFecha({ paciente: id, fecha: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.fecha : '' }));
        dispatch(setFrasco({ paciente: id, frasco: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.frasco : '' }));
        dispatch(setConcentracion({ paciente: id, concentracion: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.concentracion : '' }));
        dispatch(setVolumenAlergeno({ paciente: id, volumenAlergeno: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.volumenAlergeno : '' }));
        dispatch(setVolumenTotal({ paciente: id, volumenTotal: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.volumenTotal : '' }));
        dispatch(setSitio({ paciente: id, sitio: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.sitio : '' }));
        dispatch(setLado({ paciente: id, lado: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.lado : '' }));
        dispatch(setAlergenos({ paciente: id, alergenos: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.alergenos : [] }));
        dispatch(setAplicaciones({ paciente: id, aplicaciones: (dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.aplicaciones : [] }));
    }

    useEffect(() => {
        if(dataInmunoterapia){
            if(initInmunoterapia){
                handleSetData();
            }else{
                handleInitData();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataInmunoterapia])

    return (permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) ? (
        <>
            {(isLoading || isLoadingInmunoterapiaData)
                ? <Loader />
                : <>
                    {(isError || isErrorInmunoterapiaData)
                        ? <Error />
                        : <>
                            {(((permisos.inmunoterapiaRead || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && inmunoterapias.length === 2) || (inmunoterapias.length === 1 && nuevaStatus))
                                ? <div  className={styles.tabsContainerInmuno + " mt-3"}>
                                    <div className={"row"}>
                                        {(permisos.inmunoterapiaRead || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) &&
                                        <div className="col p-0 text-center">
                                            <div className={ (tab === 1) ? styles.tabActiveInmuno : styles.tabInmuno } onClick={() => setTab(1)}>
                                                <span className={styles.tabInmunoDropdownText}>Frasco { inmunoterapias[0].identificador }</span>
                                                {(permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) &&
                                                <div className={ (tab === 1) ? "dropdown " + styles.textTabActiveInmuno : "dropdown " + styles.textTabInmuno }>
                                                    <button className={"btn btn-secondary dropdown-toggle " + styles.tabInmunoDropdown} type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => e.stopPropagation()}>
                                                        <Icon.ThreeDotsVertical />
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {(permisos.inmunoterapiaUpdate) &&
                                                        <li className={styles.dropdownItem} onClick={(e) => handleFinalizar(e, inmunoterapias[0]._id)}><div className="dropdown-item">{(inmunoterapias[0].siguienteFlag) ? 'Siguiente': 'Finalizar'}</div></li>
                                                        }
                                                        {(permisos.inmunoterapiaDelete) &&
                                                        <li className={styles.dropdownItem} onClick={(e) => handleEliminar(e, inmunoterapias[0]._id)}><div className="dropdown-item">Eliminar</div></li>
                                                        }
                                                    </ul>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                        }
                                        {((permisos.inmunoterapiaRead || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && typeof inmunoterapias[1] !== 'undefined') &&
                                        <div className="col p-0 text-center">
                                            <div className={ (tab === 2) ? styles.tabActiveInmuno : styles.tabInmuno } onClick={() => setTab(2)}>
                                                <span className={styles.tabInmunoDropdownText}>Frasco { inmunoterapias[1].identificador }</span>
                                                {(permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) &&
                                                <div className={ (tab === 2) ? "dropdown " + styles.textTabActiveInmuno : "dropdown " + styles.textTabInmuno }>
                                                    <button className={"btn btn-secondary dropdown-toggle " + styles.tabInmunoDropdown} type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => e.stopPropagation()}>
                                                        <Icon.ThreeDotsVertical />
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {(permisos.inmunoterapiaUpdate) &&
                                                        <li className={styles.dropdownItem} onClick={(e) => handleFinalizar(e, inmunoterapias[1]._id)}><div className="dropdown-item">{(inmunoterapias[1].siguienteFlag) ? 'Siguiente': 'Finalizar'}</div></li>
                                                        }
                                                        {(permisos.inmunoterapiaDelete) &&
                                                        <li className={styles.dropdownItem} onClick={(e) => handleEliminar(e, inmunoterapias[1]._id)}><div className="dropdown-item">Eliminar</div></li>
                                                        }
                                                    </ul>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                        }
                                        {(permisos.inmunoterapiaCreate && nuevaStatus) &&
                                        <div className="col p-0 text-center">
                                            <div className={ (tab === 2) ? styles.tabActiveInmuno : styles.tabInmuno } onClick={() => setTab(2)}>
                                                <span className={styles.tabInmunoDropdownText}>Nueva</span>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                                : <div className="row">
                                    <div className="col">
                                        <div className={styles.singleTopInmunoterapias}>
                                            <span className={styles.tabsSubHeader}>{(nuevaStatus) ? 'Frasco (Nuevo)' : 'Frasco'}</span>
                                            {(!nuevaStatus && inmunoterapias.length < 2) &&
                                            <div className={styles.singleTopInmunoterapiasOptions}>
                                                {(permisos.inmunoterapiaCreate) &&
                                                <IconButton
                                                    icon="PlusCircle"
                                                    iconColor={colors.PRIMARY}
                                                    marginTop={false}
                                                    onClick={handleCrearNueva}
                                                    padding={false}
                                                    size={26}
                                                    type="button"
                                                />
                                                }
                                                {((permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && inmunoterapias.length === 1) &&
                                                <div className="dropdown ">
                                                    <button className={"btn btn-secondary dropdown-toggle " + styles.tabInmunoDropdown + " " + styles.singleTopInmunoterapiasOptionsText} type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => e.stopPropagation()}>
                                                        <Icon.ThreeDotsVertical />
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {(permisos.inmunoterapiaUpdate) &&
                                                        <li className={styles.dropdownItem} onClick={(e) => handleFinalizar(e, inmunoterapias[0]._id)}><div className="dropdown-item">{(inmunoterapias[0].siguienteFlag) ? 'Siguiente': 'Finalizar'}</div></li>
                                                        }
                                                        {(permisos.inmunoterapiaDelete) &&
                                                        <li className={styles.dropdownItem} onClick={(e) => handleEliminar(e, inmunoterapias[0]._id)}><div className="dropdown-item">Eliminar</div></li>
                                                        }
                                                    </ul>
                                                </div>
                                                }
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {(inmunoterapias.length === 0 && !nuevaStatus)
                                ? <Empty />
                                : <>
                                    {((permisos.inmunoterapiaRead || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && typeof inmunoterapias[0] !== 'undefined' && tab === 1) &&
                                        <InmunoterapiaActiva inmunoterapia={inmunoterapias[0]} paciente={id} refetchDataInmunoterapia={refetchDataInmunoterapia} setNuevaStatus={setNuevaStatus} setTab={setTab} inmunoterapiasLength={inmunoterapias.length} />
                                    }
                                    {((permisos.inmunoterapiaRead || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && typeof inmunoterapias[1] !== 'undefined' && tab === 2) &&
                                        <InmunoterapiaActiva inmunoterapia={inmunoterapias[1]} paciente={id} refetchDataInmunoterapia={refetchDataInmunoterapia} setNuevaStatus={setNuevaStatus} setTab={setTab} inmunoterapiasLength={inmunoterapias.length} />
                                    }
                                    {(permisos.inmunoterapiaCreate && nuevaStatus && ((typeof inmunoterapias[0] !== 'undefined' && tab === 2) || typeof inmunoterapias[0] === 'undefined')) &&
                                        <InmunoterapiaNueva handleCancelar={handleCancelarNueva} id={id} dataFlag={dataInmunoterapia.nueva} data={dataInmunoterapiaBrowser} dataTipos={dataInmunoterapia.tipos} dataFases={dataInmunoterapia.fases} dataFrascos={dataInmunoterapia.frascos} dataSitiosFlag={dataInmunoterapia.sitiosFlag} dataSitios={dataInmunoterapia.sitios} dataLados={dataInmunoterapia.lados} dataAlergenos={dataInmunoterapia.alergenos} dataFrecuencia={(dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.frecuencia : 0} dataDiasSemana={(dataInmunoterapia.nueva) ? dataInmunoterapia.nueva.diasSemana : {}} />
                                    }
                                </>
                            }
                        </>
                    }
                </>
            }
        </>
    ) : <Forbidden />
}

InmunoterapiaProxima.propTypes = {
    id: PropTypes.string.isRequired,
}